import * as constants from 'common/constants';
export const DEFAULT_STATE = {
  bounds: null,
  clearMarkerFlag: false,
  fields: [],
  formName: null,
  location: null,
  selectedField: null,
  selectedStorage: null,
  storages: [],
  zoom: null,
};

export default (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case constants.UPDATE_LOCATION:
      return {
        ...state,
        location: payload,
      };
    case constants.UPDATE_ZOOM:
      return {
        ...state,
        zoom: payload,
      };
    case constants.UPDATE_BOUNDS:
      return {
        ...state,
        bounds: payload,
      };
    case constants.UPDATE_SELECTED_FIELD:
      return {
        ...state,
        selectedField: payload,
      };
    case constants.UPDATE_SELECTED_STORAGE:
      return {
        ...state,
        selectedStorage: payload,
      };
    case constants.RESET_SELECTED_FIELD:
      return {
        ...state,
        selectedField: null,
      };
    case constants.RESET_SELECTED_STORAGE:
      return {
        ...state,
        selectedStorage: null,
      };
    case constants.CLEAR_MARKER:
      return {
        ...state,
        clearMarkerFlag: payload,
        selectedField: null,
      };
    case constants.UPDATE_FORM_NAME:
      return {
        ...state,
        formName: payload,
      };
    case constants.UPDATE_MAP_FIELDS:
      return {
        ...state,
        fields: payload,
      };
    case constants.UPDATE_MAP_STORAGES:
      return {
        ...state,
        storages: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/map.js